import { mapState } from 'vuex';

import { FavoriteSelectBookMixin } from '@/mixins/Bookmark/FavoriteSelectBook';

export default {
  name: 'SelectBookScrollMenu',

  mixins: [FavoriteSelectBookMixin],

  computed: {
    ...mapState('Mixins/Bookmark', {
      ms_selectedBookId: 'selectedBookId',
    }),
  },
};
